module.exports = __webpack_public_path__ + "staticcomp/img/share.fd8a039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/3/share.jpg
// module id = 8c7O
// module chunks = 39